import { render, staticRenderFns } from "./ClaimsbyProvider.vue?vue&type=template&id=7b075936&"
import script from "./ClaimsbyProvider.vue?vue&type=script&lang=js&"
export * from "./ClaimsbyProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports